<template>
  <SideMenu
    ref="sideMenu"
    :heading="$lang('product_page', 'out_of_stock_notice')"
    :side="'right'"
  >
    <div class="bg-main h-full flex flex-col">
      <div v-if="!success" class="md:px-24 px-16 pt-28 overflow-y-auto mb-80">
        <TextInput
          class="mb-24 search-input"
          :placeholder="$lang('footer', 'newsletter_signup_placeholder')"
          :has-autofocus="true"
          :has-error="emailStatus === LoadingStatuses.ERROR"
          :icon="emailStatus === LoadingStatuses.SUCCESS ? 'check' : ''"
          :icon-style="'far'"
          :is-loading="emailStatus === LoadingStatuses.LOADING"
          @submit-input="setEmail"
        />
        <transition name="fold">
          <div
            v-if="emailResponse"
            class="mt-8 text-xxs max-h-24 wp-content"
            :class="{
              'text-warning': hasEmailError,
            }"
          >
            <span v-html="emailResponse" />
          </div>
        </transition>
        <p v-if="error" class="py-12 text-xs text-warning">
          {{ $lang('product_page', 'out_of_stock_notice_error') }}
        </p>
        <ButtonComponent
          class="mt-12"
          is-large-btn
          is-block
          :text="$lang('product_page', 'out_of_stock_notice')"
          :disabled="!hasValidEmail || !hasAcceptedPolicy"
          @click="subscribe"
        />

        <div class="mt-24">
          <p class="text-grey text-xs mt-12">
            <label>
              <input
                id="newsletter"
                v-model="hasAcceptedPolicy"
                type="checkbox"
                checked="checked"
                class="inline-block w-auto mr-8"
              >
              <span>{{ $lang('general', 'approve_privacy') }}</span>
            </label>
          </p>
          <!--p class="text-grey text-xs">
            <label>
              <input
                id="newsletter"
                v-model="hasAcceptedNewsletter"
                type="checkbox"
                checked="checked"
                class="inline-block w-auto mr-8"
              >
              <span>{{ $lang('general', 'approve_newsletter') }}</span>
            </label>
          </p-->
          <p class="text-grey text-xs">
            {{$lang('product_page', 'out_of_stock_newsletter_info')}}
          </p>
        </div>
      </div>
      <div v-else class="md:px-24 px-16 pt-28 overflow-y-auto mb-80">
        <p>{{$lang('product_page', 'out_of_stock_notice_success')}}</p>
      </div>
    </div>
  </SideMenu>
</template>

<script setup lang="ts">
import useApiFetch from '~/composables/useApiFetch';
import SideMenu, { type SideMenuInterface } from '~/components/navigation/SideMenu.vue';
import TextInput from '~/components/forms/TextInput.vue';
import ButtonComponent from '~/components/forms/ButtonComponent.vue';
import LoadingStatuses from '~/constants/loading-statuses';
import Product from '~/models/product';
import { useConfigStore } from '~/store/config';

const { centraPost } = useApiFetch();
const hasEmailError = ref(false);
const hasValidEmail = ref(false);
const emailResponse = ref('');
const email = ref('');
const emailStatus = ref('');
const policyError = ref(false);
const hasAcceptedPolicy = ref(false);
const hasAcceptedNewsletter = ref(true);
const success = ref(false);
const error = ref(false);
const loading = ref(false);

const sideMenu = ref<typeof SideMenu | null>(null);

const config = useConfigStore();

onMounted(() => {
  if (sideMenu.value) {
    sideMenu.value.openOverlay();
  }
});

const props = defineProps<{
  product: {
    type: Product,
    required: true,
  },
  item: {
    type: String,
    required: true,
  },
}>();

onMounted(()=> {
  if (sideMenu.value) {
    sideMenu.value.openOverlay();
  }
});
 
const country = computed(()=> {
  return config.market?.country || '';
});

const setEmail = (input: string) => {
  if (/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(input.trim()) || !input) {
    email.value = input;
    emailResponse.value = '';
    hasEmailError.value = false;
    hasValidEmail.value = input.length > 0;
  } else {
    email.value = input;
    emailResponse.value = 'Ange en korrekt epostadress';
    hasEmailError.value = true;
    hasValidEmail.value = false;
  }
};

const subscribe = async () => {
  if (!hasValidEmail.value || !hasAcceptedPolicy.value) {
    emailStatus.value = '';
    return;  
  }
  emailStatus.value = LoadingStatuses.LOADING;
  policyError.value = false;
  if (email.value && !hasEmailError.value) {
    if (!hasAcceptedPolicy.value) {
      policyError.value = true;
      return;
    }
    loading.value = true;
    const res = await centraPost(`/back-in-stock-subscription`, {
      email: email.value,
      item: props.item,
      shipTo: {
        country: country.value.toUpperCase(),
      },
    });
    if (hasAcceptedNewsletter.value) {
      const newsletterRes = await centraPost(`/newsletter-subscription/${encodeURIComponent(email.value)}`, {
        country: country.value.toUpperCase(),
      });
      console.log('newsletter: ' + JSON.stringify(newsletterRes));
    };
    //console.log('email: ' + email.value);
    //console.log('item: ' + props.item);
    //console.log('country: ' + country.value.toUpperCase());
    //console.log('back in stock: ' + JSON.stringify(res));
    if (res) {
      success.value = true;
    } else {
      emailStatus.value = LoadingStatuses.ERROR;
      error.value = true;
      loading.value = false;
    }
  }
};         
</script>
